import * as types from '../../actionTypes'

export const setSelectedFile = file => ({
  type: types.SITE_PREFERENCES_FILE_SELECTED,
  file,
})
export const setIsSubmitting = () => ({
  type: types.SITE_PREFERENCES_FILE_SUBMITTING,
})

export const setSubmittingSuccess = data => ({
  type: types.SITE_PREFERENCES_FILE_SUCCEEDED,
  data,
})

export const setSubmittingError = (errorMessage, file) => ({
  type: types.SITE_PREFERENCES_FILE_ERROR,
  error: errorMessage,
  file: file,
})



// WEBPACK FOOTER //
// ./src/redux/css-admin/sitePreferences/actions.js